interface ToggleChipProps {
  active: boolean;
  label: string;
  title: string;
  onToggle(): void;
}

/** Switch-style toolbar toggle (legacy `.toolbar-toggle-chip`). */
export function ToggleChip({ active, label, title, onToggle }: ToggleChipProps) {
  return (
    <button
      type="button"
      className={`objective-chip toolbar-toggle-chip${active ? " active" : ""}`}
      title={title}
      aria-pressed={active}
      onClick={onToggle}
    >
      <span
        className={`objective-chip-icon toggle-switch-icon${active ? " toggle-switch-icon-on" : ""}`}
      >
        <span className="toggle-switch-knob" />
      </span>
      <span className="objective-chip-label">{label}</span>
    </button>
  );
}
